import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $, { escapeSelector } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class VirtualAgentSkills extends Component {
    constructor() {
        super();
        this.state = {
            disabled: false,
            dataStartedProcessing: false,
            savingData: false,
            data: [],
            editedId: "-1",
            dummyUUID: "00000000-0000-0000-0000-000000000000",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            editedName: "",
            editedDescription: "",
            searchTerm: "",
            noMatchingData: false,
            isLoading: true,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchVirtualAgentSkills();
        }, 300);


    }
    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/ai-agent",
            state: {
                goBackToFaq: true,
                pageNum: pageNum,
                virtualAgentId: this.props.location.state.virtualAgentId,
            }
        });
    }
    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.data = [];
        this.state.editedId = "-1";
        this.state.disabled = false;
        this.state.noMatchingData = false;
        this.state.isLoading = true;
        this.state.searchTerm = "";
        this.setState(this.state);
        this.fetchVirtualAgentSkills();
    }

    fetchVirtualAgentSkills = () => {
        var thisController = this;
        var virtualAgentId = thisController.props.location.state.virtualAgentId;
        if (virtualAgentId == "") {
            virtualAgentId = thisController.state.dummyUUID;
        }
        $.ajax({
            url: "/my-jeeva-api/load-agent-skills",

            method: 'GET',
            data: {
                virtualAgentId: virtualAgentId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.showLoader = true;
                    thisController.state.noMatchingData = false;
                    thisController.state.isLoading = false;
                    thisController.state.data = messages;
                    thisController.data = messages;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }


    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no virtual agent skill present. </p>
        </div>
    );

    saveVirtualAgentSkillApi = (props, e) => {

        if (this.state.savingData) {
            return;
        }
        this.setState({ savingData: true });

        var thisController = this;
        var skillName = document.getElementById("name" + props.id).innerText.trim();
        var skillDescription = document.getElementById("description" + props.id).innerText.trim();
        var virtualAgentId = thisController.props.location.state.virtualAgentId;

        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        if (skillName == "") {
            thisController.setState({ savingData: false });
            thisController.notifyMsgFieldEmpty();
        }
        else if (!namePattern.test(skillName)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperName();
        }
        else if (virtualAgentId == "") {
            thisController.setState({ savingData: false });
            // thisController.notifyError()
        } else {
            var saveData = {
                virtualAgentId: thisController.props.location.state.virtualAgentId,
                name: document.getElementById("name" + props.id).innerText.trim(),
                description: document.getElementById("description" + props.id).innerText.trim(),

            }

            $.ajax({
                url: "/my-jeeva-api/add-agent-skill",

                method: 'POST',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json",

                },
                success: function (res) {
                    if (res.success === true) {

                        thisController.notifyAdded();
                        thisController.state.disabled = false;
                        thisController.fetchVirtualAgentSkills();

                    } else {
                        // thisController.notifyError();
                        thisController.state.disabled = false;
                    }
                    thisController.setState({ savingData: false });
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    updatevirtualAgentSkillsApi(props, e) {
        var thisController = this
        var skillName = thisController.state.editedName;
        var skillDescription = thisController.state.editedDescription;
        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        if (skillName == "") {
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(skillName)) {
            thisController.notifyImproperName();
        } else {

            var updateData = {
                id: props.id,
                virtualAgentId: thisController.props.location.state.virtualAgentId,
                name: skillName,
                description: skillDescription
            }

            $.ajax({
                url: "/my-jeeva-api/update-agent-skill",

                method: 'PATCH',
                data: JSON.stringify(updateData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success == true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.setState(thisController.state);
                        thisController.fetchVirtualAgentSkills();
                    } else {
                        // thisController.notifyError();
                        thisController.state.disabled = false;
                        thisController.setState(thisController.state);
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    addNewAgentSkillRow = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            agentId: '',
            name: '',
            description: ''
        });
        this.setState({
            data: this.state.data,
            noMatchingData: false,
            disabled: true,
        })
    }
    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
        this.state.editedName = props.name;
        this.state.editedDescription = props.description;
        this.setState(this.state);

    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.name} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteVirtualAgentSkillApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    deleteVirtualAgentSkillApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;
        var id = props.id;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-agent-skill/" + id,

                method: 'DELETE',
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyDelete();
                        deleteConstructorVariables.refreshData();

                    } else {
                        // deleteConstructorVariables.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }

    handleNameChange = (e) => {
        this.state.editedName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleDescriptionChange = (e) => {
        this.state.editedDescription = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Virtual Agent Skills has been added successfully</b>, {
            position: "top-center",

        });

    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Virtual Agent Skills has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Virtual Agent Skill deleted successfully</b>, {
            position: "top-center",
        });
    }
    configureSikllData = (row, e) => {
        this.props.history.push({
            pathname: '/projectmgmt/skill-meta-data',
            state: {
                skillId: row.id,
                skillName: row.name,
                pageNum: this.state.pageNum,
                virtualAgentId: this.props.location.state.virtualAgentId,
                VirtualAgentName: this.props.location.state.VirtualAgentName
            }
        });
        this.setState(this.setState)
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        var virtualAgentId = thisController.props.location.state.virtualAgentId;
        if (virtualAgentId == "") {
            virtualAgentId = thisController.state.dummyUUID;
        }
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-agent-skills",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm,
                virtualAgentId: virtualAgentId
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });
    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchVirtualAgentSkills();
        });
    }

    render() {
        const { data } = this.state;
        var agentController = this;

        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('name'),
                width: "19vw",
                selector: (row) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleNameChange(e, row);
                            }}
                            id={"name" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.name}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Description</b>,
                width: "45vw",
                sortable: true,
                sortFunction: this.caseInsensitiveSort('description'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll"
                            }}
                            onInput={(e) => {
                                this.handleDescriptionChange(e, row)
                            }}
                            id={"description" + row.id}
                            name={"description" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.description}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: '16px' }}>Actions</b>,
                width: 100,
                selector: (props) => (
                    <div id="action">

                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none"
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                title={props.id == "" || (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.saveVirtualAgentSkillApi(props, e) :
                                        (props.id == this.state.editedId) ?
                                            this.updatevirtualAgentSkillsApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.id) === '' ?
                                    this.fetchVirtualAgentSkills() :
                                    this.openDeletePopUp(props)}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                            }}
                            title="Configure Skill Data"
                            onClick={(e) => {
                                this.configureSikllData(props, e);
                            }}
                        >
                            <img
                                className="img-responsive"
                                style={{
                                    marginTop: "6px",
                                    backgroundColor: "#282a65",
                                    borderRadius: "5px",
                                    padding: "1px"
                                }}
                                src="./assets/images/manage.png"
                            />
                        </button>
                    </div>
                ),

            },

        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw" }}>
                                <h6 style={{ color: '#282a65', textAlign: 'center', marginTop: '20px' }}>
                                    Skills of {this.props.location.state.VirtualAgentName}</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "50vw", marginTop: "1vh" }}>
                                <input
                                    type="text"
                                    style={{
                                        width: "10vw",
                                        border: "1px solid #777676",
                                        borderRadius: "3px",
                                        padding: "10px",
                                        height: "0.6vw",
                                        paddingRight: "2rem",
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                                {this.state.searchTerm && (
                                    <span
                                        onClick={() => this.clearSearchData()}
                                        style={{
                                            // position: "absolute",
                                            right: "8px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#777676",
                                            fontSize: "1.2rem",
                                            fontWeight: "bold",
                                            lineHeight: 1,
                                            userSelect: "none",
                                            marginLeft: "-1vw"
                                        }}
                                    >
                                        ×
                                    </span>
                                )}
                            </div>
                            {/* Add button */}
                            <div
                                style={{ marginLeft: "3vw" }}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewAgentSkillRow}
                                >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button
                                    onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginLeft: '15px', marginTop: '10px' }}>
                        <div className="col-lg-12 ">
                            {!this.state.noMatchingData &&
                                <div className="card">
                                    {this.state.isLoading && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>Loading ...</p>
                                        </div>
                                    )}
                                    {!this.state.isLoading && this.state.data.length === 0 && (
                                        <div style={{ padding: '20px', textAlign: 'center' }}>
                                            <p>There are no virtual agent skill present.</p>
                                        </div>
                                    )}
                                    {(!this.state.isLoading && this.state.data.length > 0) && (

                                        <DataTable
                                            data={this.state.data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            pagination={this.state.paginationValue}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                            noDataComponent={<this.CustomNoDataComponent />}
                                        />
                                    )}
                                </div>
                            }
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default VirtualAgentSkills;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/VirtualAgentSkills.js